module.exports = __webpack_public_path__ + "static/img/Nino Utopie Asomado.ef30e907.svg";